import { useState } from 'react'
import { Link } from 'react-router-dom'

interface Diary {
  id: string
  date: string
  researchId: string
  patientName: string
  patientKarte: string
  primaryDoctor: string
  transplantDoctor: string
  recorder: string
  recorderName: string
  content: string
}

const initialDiaries: Diary[] = [
  {
    id: 'asd-001',
    date: '2025-11-28',
    researchId: 'R01166',
    patientName: 'SymTsk',
    patientKarte: '（閲覧権限なし）',
    primaryDoctor: '医療法人感謝会',
    transplantDoctor: '医療法人感謝会',
    recorder: '父',
    recorderName: '（閲覧権限なし）',
    content: '今日の様子：落ち着いている。食事もよく食べた。睡眠は良好。',
  },
  {
    id: 'asd-002',
    date: '2025-11-27',
    researchId: 'R01166',
    patientName: 'SymTsk',
    patientKarte: '（閲覧権限なし）',
    primaryDoctor: '医療法人感謝会',
    transplantDoctor: '医療法人感謝会',
    recorder: '父',
    recorderName: '（閲覧権限なし）',
    content: '少し興奮気味だったが、夕方には落ち着いた。',
  },
  {
    id: 'asd-003',
    date: '2025-11-26',
    researchId: 'R01594',
    patientName: 'FmtHrv',
    patientKarte: '（閲覧権限なし）',
    primaryDoctor: '医療法人LAGOM',
    transplantDoctor: '医療法人LAGOM',
    recorder: '母',
    recorderName: '（閲覧権限なし）',
    content: '言葉が少し増えた気がする。目が合う回数も増えている。',
  },
  {
    id: 'asd-004',
    date: '2025-11-25',
    researchId: 'R01645',
    patientName: 'YsmrYuk',
    patientKarte: '（閲覧権限なし）',
    primaryDoctor: 'よろずクリニック',
    transplantDoctor: 'よろずクリニック',
    recorder: '母',
    recorderName: '（閲覧権限なし）',
    content: '睡眠の質が改善している。夜泣きが減った。',
  },
  {
    id: 'asd-005',
    date: '2025-11-24',
    researchId: 'R01645',
    patientName: 'YsmrYuk',
    patientKarte: '（閲覧権限なし）',
    primaryDoctor: 'よろずクリニック',
    transplantDoctor: 'よろずクリニック',
    recorder: '母',
    recorderName: '（閲覧権限なし）',
    content: '今日は調子が良かった。新しいおもちゃに興味を示した。',
  },
  {
    id: 'asd-006',
    date: '2025-11-23',
    researchId: 'R01166',
    patientName: 'SymTsk',
    patientKarte: '（閲覧権限なし）',
    primaryDoctor: '医療法人感謝会',
    transplantDoctor: '医療法人感謝会',
    recorder: '父',
    recorderName: '（閲覧権限なし）',
    content: 'コミュニケーションが取りやすくなってきた。',
  },
]

export default function AsdDiaryList() {
  const [diaries, setDiaries] = useState<Diary[]>(initialDiaries)
  const [searchQuery, setSearchQuery] = useState('')
  const [selectedDiaries, setSelectedDiaries] = useState<string[]>([])
  const [isModalOpen, setIsModalOpen] = useState(false)
  const [isDetailOpen, setIsDetailOpen] = useState(false)
  const [selectedDiary, setSelectedDiary] = useState<Diary | null>(null)
  const [editingDiary, setEditingDiary] = useState<Diary | null>(null)
  const [notification, setNotification] = useState<{ type: 'success' | 'error', message: string } | null>(null)
  const [formData, setFormData] = useState({
    date: '',
    researchId: '',
    patientName: '',
    recorder: '',
    content: '',
  })

  const filteredDiaries = diaries.filter(
    (diary) =>
      diary.patientName.toLowerCase().includes(searchQuery.toLowerCase()) ||
      diary.researchId.toLowerCase().includes(searchQuery.toLowerCase())
  )

  const toggleSelectAll = () => {
    if (selectedDiaries.length === filteredDiaries.length) {
      setSelectedDiaries([])
    } else {
      setSelectedDiaries(filteredDiaries.map((d) => d.id))
    }
  }

  const toggleSelect = (id: string) => {
    setSelectedDiaries((prev) =>
      prev.includes(id) ? prev.filter((d) => d !== id) : [...prev, id]
    )
  }

  const showNotification = (type: 'success' | 'error', message: string) => {
    setNotification({ type, message })
    setTimeout(() => setNotification(null), 3000)
  }

  const openCreateModal = () => {
    setEditingDiary(null)
    setFormData({
      date: new Date().toISOString().split('T')[0],
      researchId: '',
      patientName: '',
      recorder: '',
      content: '',
    })
    setIsModalOpen(true)
  }

  const openEditModal = (diary: Diary) => {
    setEditingDiary(diary)
    setFormData({
      date: diary.date,
      researchId: diary.researchId,
      patientName: diary.patientName,
      recorder: diary.recorder,
      content: diary.content,
    })
    setIsModalOpen(true)
  }

  const openDetailModal = (diary: Diary) => {
    setSelectedDiary(diary)
    setIsDetailOpen(true)
  }

  const closeModal = () => {
    setIsModalOpen(false)
    setIsDetailOpen(false)
    setEditingDiary(null)
    setSelectedDiary(null)
  }

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault()

    if (!formData.date || !formData.researchId || !formData.content) {
      showNotification('error', '必須項目を入力してください')
      return
    }

    if (editingDiary) {
      setDiaries(diaries.map(d =>
        d.id === editingDiary.id
          ? { ...d, ...formData, patientKarte: '（閲覧権限なし）', recorderName: '（閲覧権限なし）', primaryDoctor: d.primaryDoctor, transplantDoctor: d.transplantDoctor }
          : d
      ))
      showNotification('success', 'ダイアリーを更新しました')
    } else {
      const newDiary: Diary = {
        id: `asd-${Date.now()}`,
        date: formData.date,
        researchId: formData.researchId,
        patientName: formData.patientName,
        patientKarte: '（閲覧権限なし）',
        primaryDoctor: '未設定',
        transplantDoctor: '未設定',
        recorder: formData.recorder,
        recorderName: '（閲覧権限なし）',
        content: formData.content,
      }
      setDiaries([newDiary, ...diaries])
      showNotification('success', 'ダイアリーを登録しました')
    }

    closeModal()
  }

  const handleDelete = () => {
    if (selectedDiaries.length === 0) return
    if (window.confirm(`${selectedDiaries.length}件のダイアリーを削除してもよろしいですか？`)) {
      setDiaries(diaries.filter(d => !selectedDiaries.includes(d.id)))
      setSelectedDiaries([])
      showNotification('success', 'ダイアリーを削除しました')
    }
  }

  const handleDownload = () => {
    const csvContent = [
      ['日付', '研究会ID', '患者名', '記入者', '内容'].join(','),
      ...filteredDiaries.map(d => [
        d.date,
        d.researchId,
        d.patientName,
        d.recorder,
        `"${d.content.replace(/"/g, '""')}"`
      ].join(','))
    ].join('\n')

    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' })
    const link = document.createElement('a')
    link.href = URL.createObjectURL(blob)
    link.download = `asd_diaries_${new Date().toISOString().split('T')[0]}.csv`
    link.click()
    showNotification('success', 'CSVファイルをダウンロードしました')
  }

  return (
    <>
      <header className="aip-main__header">
        <div className="aip-main__header-container">
          <h1 className="aip-main__header-title">ASD菌力UPダイアリー</h1>
          <div className="aip-main__header-buttons">
            <button onClick={openCreateModal} className="aip-button aip-button--solid-fill">
              <span className="material-symbols-outlined">add</span>
              新規作成
            </button>
          </div>
        </div>
      </header>

      <div className="aip-main__content">
        {/* 通知 */}
        {notification && (
          <div className={`notification notification--${notification.type}`}>
            <span className="material-symbols-outlined">
              {notification.type === 'success' ? 'check_circle' : 'error'}
            </span>
            {notification.message}
          </div>
        )}

        <div className="list-container">
          {/* ツールバー */}
          <div className="aip-table__header">
            <div className="aip-table__header-area">
              <div className="aip-search-bar">
                <span className="material-symbols-outlined aip-search-bar__icon">search</span>
                <input
                  className="aip-search-bar__input"
                  type="text"
                  placeholder="患者名、研究会IDで検索"
                  value={searchQuery}
                  onChange={(e) => setSearchQuery(e.target.value)}
                />
              </div>

              <button onClick={handleDownload} className="aip-button aip-button--icon" title="CSVダウンロード">
                <span className="material-symbols-outlined">download</span>
              </button>
            </div>
          </div>

          {/* 選択時のアクションバー */}
          {selectedDiaries.length > 0 && (
            <div className="aip-table__selection-bar">
              <span>{selectedDiaries.length}件選択中</span>
              <button onClick={handleDelete} className="aip-button aip-button--outline">
                <span className="material-symbols-outlined">delete</span>
                削除
              </button>
            </div>
          )}

          {/* テーブル */}
          <div className="aip-table-wrapper">
            <table className="aip-table">
              <thead>
                <tr>
                  <th className="aip-table__checkbox-cell">
                    <input
                      type="checkbox"
                      checked={selectedDiaries.length === filteredDiaries.length && filteredDiaries.length > 0}
                      onChange={toggleSelectAll}
                    />
                  </th>
                  <th>日付</th>
                  <th>研究会ID</th>
                  <th>氏名（姓）患者カルテ</th>
                  <th>（名）患者カルテ</th>
                  <th>主治医</th>
                  <th>移植担当医</th>
                  <th>記入者</th>
                  <th>氏名（姓）</th>
                  <th>（名）</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                {filteredDiaries.map((diary) => (
                  <tr key={diary.id}>
                    <td className="aip-table__checkbox-cell">
                      <input
                        type="checkbox"
                        checked={selectedDiaries.includes(diary.id)}
                        onChange={() => toggleSelect(diary.id)}
                      />
                    </td>
                    <td>
                      <button onClick={() => openDetailModal(diary)} className="aip-table__link-btn">
                        {diary.date}
                      </button>
                    </td>
                    <td>
                      <Link to={`/patients/${diary.researchId}`} className="aip-table__link">
                        {diary.researchId}
                      </Link>
                    </td>
                    <td>{diary.patientKarte}</td>
                    <td>{diary.patientKarte}</td>
                    <td className="doctor-cell">
                      <span className="doctor-icon">👨‍⚕️</span>
                      {diary.primaryDoctor}
                    </td>
                    <td className="doctor-cell">
                      <span className="doctor-icon">👨‍⚕️</span>
                      {diary.transplantDoctor}
                    </td>
                    <td>{diary.recorder}</td>
                    <td>{diary.recorderName}</td>
                    <td>{diary.recorderName}</td>
                    <td>
                      <div className="aip-table__actions">
                        <button 
                          onClick={() => openDetailModal(diary)} 
                          className="aip-button aip-button--icon aip-button--sm" 
                          title="詳細"
                        >
                          <span className="material-symbols-outlined">visibility</span>
                        </button>
                        <button 
                          onClick={() => openEditModal(diary)} 
                          className="aip-button aip-button--icon aip-button--sm" 
                          title="編集"
                        >
                          <span className="material-symbols-outlined">edit</span>
                        </button>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          {/* ページネーション */}
          <div className="aip-table__pagination">
            <span className="aip-table__pagination-info">
              1 - {filteredDiaries.length} （{diaries.length}件中）
            </span>
            <div className="aip-table__pagination-controls">
              <button className="aip-button aip-button--icon" disabled>
                <span className="material-symbols-outlined">chevron_left</span>
              </button>
              <button className="aip-button aip-button--icon">
                <span className="material-symbols-outlined">chevron_right</span>
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* 詳細モーダル */}
      {isDetailOpen && selectedDiary && (
        <div className="modal-overlay" onClick={closeModal}>
          <div className="modal modal--detail" onClick={(e) => e.stopPropagation()}>
            <div className="modal__header">
              <h2 className="modal__title">ダイアリー詳細</h2>
              <button onClick={closeModal} className="modal__close">
                <span className="material-symbols-outlined">close</span>
              </button>
            </div>
            <div className="modal__body">
              <div className="detail-grid">
                <div className="detail-item">
                  <label>日付</label>
                  <span>{selectedDiary.date}</span>
                </div>
                <div className="detail-item">
                  <label>研究会ID</label>
                  <span>{selectedDiary.researchId}</span>
                </div>
                <div className="detail-item">
                  <label>患者名</label>
                  <span>{selectedDiary.patientName}</span>
                </div>
                <div className="detail-item">
                  <label>記入者</label>
                  <span>{selectedDiary.recorder}</span>
                </div>
              </div>
              <div className="detail-content">
                <label>内容</label>
                <p>{selectedDiary.content}</p>
              </div>
              <div className="modal__footer">
                <button onClick={closeModal} className="aip-button aip-button--outline">
                  閉じる
                </button>
                <button onClick={() => { closeModal(); openEditModal(selectedDiary); }} className="aip-button aip-button--solid-fill">
                  編集
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* 作成・編集モーダル */}
      {isModalOpen && (
        <div className="modal-overlay" onClick={closeModal}>
          <div className="modal" onClick={(e) => e.stopPropagation()}>
            <div className="modal__header">
              <h2 className="modal__title">
                {editingDiary ? 'ダイアリーの編集' : 'ダイアリーの新規作成'}
              </h2>
              <button onClick={closeModal} className="modal__close">
                <span className="material-symbols-outlined">close</span>
              </button>
            </div>
            <form onSubmit={handleSubmit} className="modal__body">
              <div className="form-grid">
                <div className="form-group">
                  <label className="form-label">
                    日付 <span className="required">*</span>
                  </label>
                  <input
                    type="date"
                    className="form-input"
                    value={formData.date}
                    onChange={(e) => setFormData({ ...formData, date: e.target.value })}
                  />
                </div>
                <div className="form-group">
                  <label className="form-label">
                    研究会ID <span className="required">*</span>
                  </label>
                  <input
                    type="text"
                    className="form-input"
                    value={formData.researchId}
                    onChange={(e) => setFormData({ ...formData, researchId: e.target.value })}
                    placeholder="R00000"
                  />
                </div>
                <div className="form-group">
                  <label className="form-label">患者名</label>
                  <input
                    type="text"
                    className="form-input"
                    value={formData.patientName}
                    onChange={(e) => setFormData({ ...formData, patientName: e.target.value })}
                  />
                </div>
                <div className="form-group">
                  <label className="form-label">記入者</label>
                  <select
                    className="form-input"
                    value={formData.recorder}
                    onChange={(e) => setFormData({ ...formData, recorder: e.target.value })}
                  >
                    <option value="">選択してください</option>
                    <option value="父">父</option>
                    <option value="母">母</option>
                    <option value="本人">本人</option>
                    <option value="その他">その他</option>
                  </select>
                </div>
              </div>
              <div className="form-group">
                <label className="form-label">
                  内容 <span className="required">*</span>
                </label>
                <textarea
                  className="form-input form-textarea"
                  rows={5}
                  value={formData.content}
                  onChange={(e) => setFormData({ ...formData, content: e.target.value })}
                  placeholder="今日の様子を記入してください"
                />
              </div>
              <div className="modal__footer">
                <button type="button" onClick={closeModal} className="aip-button aip-button--outline">
                  キャンセル
                </button>
                <button type="submit" className="aip-button aip-button--solid-fill">
                  {editingDiary ? '更新' : '登録'}
                </button>
              </div>
            </form>
          </div>
        </div>
      )}

      <style>{`
        .list-container {
          background-color: var(--background-primary);
          border-radius: var(--border-radius-lg);
          box-shadow: var(--shadow-sm);
        }

        .aip-table__header {
          display: flex;
          justify-content: space-between;
          align-items: center;
          padding: var(--spacing-md);
          border-bottom: 1px solid var(--border-color);
        }

        .aip-table__header-area {
          display: flex;
          align-items: center;
          gap: var(--spacing-sm);
          flex-wrap: wrap;
        }

        .aip-table__header-area .aip-search-bar {
          min-width: 250px;
        }

        .aip-table__selection-bar {
          display: flex;
          align-items: center;
          gap: var(--spacing-md);
          padding: var(--spacing-sm) var(--spacing-md);
          background-color: var(--color-blue50);
          border-bottom: 1px solid var(--color-blue200);
        }

        .aip-table-wrapper {
          overflow-x: auto;
        }

        .aip-table {
          width: 100%;
          border-collapse: collapse;
        }

        .aip-table th,
        .aip-table td {
          padding: var(--spacing-sm) var(--spacing-md);
          text-align: left;
          border-bottom: 1px solid var(--border-color);
          white-space: nowrap;
          font-size: 0.8125rem;
        }

        .aip-table th {
          background-color: var(--color-solid-gray25);
          font-weight: 500;
          font-size: 0.75rem;
          color: var(--text-secondary);
        }

        .aip-table tbody tr:hover {
          background-color: var(--color-solid-gray25);
        }

        .aip-table__checkbox-cell {
          width: 40px;
        }

        .aip-table__link, .aip-table__link-btn {
          color: var(--color-blue600);
          font-weight: 500;
          background: none;
          border: none;
          cursor: pointer;
          font-size: inherit;
          padding: 0;
        }

        .aip-table__link:hover, .aip-table__link-btn:hover {
          text-decoration: underline;
        }

        .doctor-cell {
          display: flex;
          align-items: center;
          gap: var(--spacing-xs);
        }

        .doctor-icon {
          font-size: 1rem;
        }

        .aip-table__actions {
          display: flex;
          gap: var(--spacing-xs);
        }

        .aip-table__pagination {
          display: flex;
          justify-content: space-between;
          align-items: center;
          padding: var(--spacing-md);
          border-top: 1px solid var(--border-color);
        }

        .aip-table__pagination-info {
          font-size: 0.875rem;
          color: var(--text-secondary);
        }

        .aip-table__pagination-controls {
          display: flex;
          gap: var(--spacing-xs);
        }

        /* 通知 */
        .notification {
          display: flex;
          align-items: center;
          gap: var(--spacing-sm);
          padding: var(--spacing-md);
          border-radius: var(--border-radius-md);
          margin-bottom: var(--spacing-md);
          animation: slideIn 0.3s ease;
        }

        .notification--success {
          background-color: var(--color-success-light);
          color: var(--color-success);
        }

        .notification--error {
          background-color: var(--color-alert-light);
          color: var(--color-alert);
        }

        @keyframes slideIn {
          from { opacity: 0; transform: translateY(-10px); }
          to { opacity: 1; transform: translateY(0); }
        }

        /* モーダル */
        .modal-overlay {
          position: fixed;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background-color: rgba(0, 0, 0, 0.5);
          display: flex;
          align-items: center;
          justify-content: center;
          z-index: 1000;
        }

        .modal {
          background-color: var(--background-primary);
          border-radius: var(--border-radius-lg);
          box-shadow: var(--shadow-lg);
          width: 100%;
          max-width: 600px;
          max-height: 90vh;
          overflow: auto;
        }

        .modal--detail {
          max-width: 500px;
        }

        .modal__header {
          display: flex;
          align-items: center;
          justify-content: space-between;
          padding: var(--spacing-md) var(--spacing-lg);
          border-bottom: 1px solid var(--border-color);
        }

        .modal__title {
          font-size: 1.125rem;
          font-weight: 600;
        }

        .modal__close {
          background: none;
          border: none;
          color: var(--text-secondary);
          cursor: pointer;
          padding: var(--spacing-xs);
          border-radius: var(--border-radius-sm);
        }

        .modal__close:hover {
          background-color: var(--color-solid-gray100);
        }

        .modal__body {
          padding: var(--spacing-lg);
        }

        .modal__footer {
          display: flex;
          justify-content: flex-end;
          gap: var(--spacing-sm);
          margin-top: var(--spacing-lg);
          padding-top: var(--spacing-md);
          border-top: 1px solid var(--border-color);
        }

        .detail-grid {
          display: grid;
          grid-template-columns: repeat(2, 1fr);
          gap: var(--spacing-md);
          margin-bottom: var(--spacing-md);
        }

        .detail-item label {
          display: block;
          font-size: 0.75rem;
          color: var(--text-secondary);
          margin-bottom: var(--spacing-xs);
        }

        .detail-item span {
          font-weight: 500;
        }

        .detail-content {
          padding: var(--spacing-md);
          background-color: var(--color-solid-gray25);
          border-radius: var(--border-radius-md);
        }

        .detail-content label {
          display: block;
          font-size: 0.75rem;
          color: var(--text-secondary);
          margin-bottom: var(--spacing-sm);
        }

        .detail-content p {
          white-space: pre-wrap;
        }

        .form-grid {
          display: grid;
          grid-template-columns: repeat(2, 1fr);
          gap: var(--spacing-md);
          margin-bottom: var(--spacing-md);
        }

        .form-group {
          margin-bottom: var(--spacing-md);
        }

        .form-label {
          display: block;
          font-size: 0.875rem;
          font-weight: 500;
          margin-bottom: var(--spacing-xs);
        }

        .required {
          color: var(--color-alert);
        }

        .form-input {
          width: 100%;
          padding: var(--spacing-sm) var(--spacing-md);
          border: 1px solid var(--border-color);
          border-radius: var(--border-radius-md);
          font-size: 0.875rem;
        }

        .form-input:focus {
          outline: none;
          border-color: var(--color-blue500);
          box-shadow: 0 0 0 3px var(--color-blue100);
        }

        .form-textarea {
          resize: vertical;
          font-family: inherit;
        }

        .aip-button--outline {
          background-color: transparent;
          border: 1px solid var(--border-color);
          color: var(--text-primary);
        }

        .aip-button--outline:hover {
          background-color: var(--color-solid-gray50);
        }

        .aip-button--icon {
          padding: var(--spacing-xs);
          border: none;
          background: none;
          color: var(--text-secondary);
          border-radius: var(--border-radius-sm);
          cursor: pointer;
        }

        .aip-button--icon:hover {
          background-color: var(--color-solid-gray50);
          color: var(--text-primary);
        }

        .aip-button--sm {
          padding: 4px;
        }

        .aip-button--sm .material-symbols-outlined {
          font-size: 20px;
        }
      `}</style>
    </>
  )
}
